import store from '../../store'

const useUserId = () => {

    const userId = store.state.user && store.state.user.uid

    return {
        userId
    }
}

export default useUserId